import React, { useState, useEffect } from 'react';
import GeneralEvolutionListMobile from './generalEvolutionListMobile';
import GeneralEvolutionListWeb from './generalEvolutionListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const GeneralEvolutionListRouter = (props) => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  if (width === 0) {
    return null;
  }

  return width < MOBILE_BREAKPOINT ? (
    <GeneralEvolutionListMobile {...props} />
  ) : (
    <GeneralEvolutionListWeb {...props} />
  );
};

export default GeneralEvolutionListRouter;
